import React, { useState } from "react";
import { motion } from "framer-motion";
import { X, Check } from "lucide-react";
import { formatPrice } from "./constants";

export default function EnrollmentModal({ isOpen, onClose, onSubmit, programLabel, subtotal, gst, total, isProcessing, paymentStatus }) {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  if (!isOpen) return null;
  const inputClass = "w-full bg-[#0A1711] border border-[#F7F5F0]/10 px-4 py-3.5 text-[#F7F5F0] placeholder-[#A3B8AD]/40 focus:border-[#D4AF37]/50 focus:outline-none rounded-xl text-sm";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-md" data-testid="enrollment-modal">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
        className="bg-[#0D1F17] border border-[#F7F5F0]/10 p-8 w-full max-w-md rounded-2xl max-h-[90vh] overflow-y-auto shadow-2xl">
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-serif text-2xl text-[#F7F5F0]">Complete Enrollment</h3>
          <button onClick={onClose} className="p-2 hover:bg-[#F7F5F0]/5 rounded-full text-[#A3B8AD]" data-testid="close-modal"><X size={20} /></button>
        </div>
        <div className="bg-[#0A1711] rounded-xl p-5 mb-6 border border-[#F7F5F0]/5">
          <p className="text-xs text-[#A3B8AD] uppercase tracking-wider">You are enrolling in</p>
          <p className="text-[#F7F5F0] font-serif text-lg mt-1">{programLabel}</p>
          <div className="mt-3 space-y-1.5 text-sm">
            <div className="flex justify-between"><span className="text-[#A3B8AD]">Subtotal</span><span className="text-[#F7F5F0]">{"\u20B9"}{formatPrice(subtotal)}</span></div>
            <div className="flex justify-between" data-testid="modal-gst"><span className="text-[#A3B8AD]">GST (18%)</span><span className="text-[#F7F5F0]">{"\u20B9"}{formatPrice(gst)}</span></div>
            <div className="flex justify-between pt-2 border-t border-[#F7F5F0]/10 font-serif">
              <span className="text-[#D4AF37]">Total</span>
              <span className="text-[#F7F5F0] text-xl" data-testid="modal-total">{"\u20B9"}{formatPrice(total)}</span>
            </div>
          </div>
        </div>
        {paymentStatus?.type === "success" ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#D4AF37]/10 flex items-center justify-center"><Check size={28} className="text-[#D4AF37]" /></div>
            <p className="text-[#F7F5F0] font-serif text-xl">{paymentStatus.message}</p>
          </div>
        ) : (
          <form onSubmit={(e) => { e.preventDefault(); onSubmit(formData); }} className="space-y-4">
            <div>
              <label className="block text-xs text-[#A3B8AD] mb-1.5 tracking-wider">Full Name *</label>
              <input type="text" required value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Your full name" data-testid="enroll-name" className={inputClass} />
            </div>
            <div>
              <label className="block text-xs text-[#A3B8AD] mb-1.5 tracking-wider">Email *</label>
              <input type="email" required value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="your@email.com" data-testid="enroll-email" className={inputClass} />
            </div>
            <div>
              <label className="block text-xs text-[#A3B8AD] mb-1.5 tracking-wider">Phone *</label>
              <input type="tel" required value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                placeholder="Your phone number" data-testid="enroll-phone" className={inputClass} />
            </div>
            {paymentStatus?.type === "error" && <p className="text-red-400 text-sm">{paymentStatus.message}</p>}
            <button type="submit" disabled={isProcessing} data-testid="enroll-pay-btn"
              className="w-full bg-[#D4AF37] text-[#0D1F17] py-4 text-sm font-bold tracking-wide rounded-full hover:bg-[#B5952F] transition-all disabled:opacity-50 mt-2">
              {isProcessing ? "Processing..." : `Pay \u20B9${formatPrice(total)}`}
            </button>
          </form>
        )}
      </motion.div>
    </div>
  );
}
